import { Dispatch, SetStateAction, useContext, useEffect } from "react";
import { Follow } from "./Follow";
import { UserContext, iUserFollower } from "../../../../../providers/UserContext";
import { FollowCard } from "./FollowCard";

interface iFollower {
    setShowFollowers: Dispatch<SetStateAction<boolean>>;
    userPage: iUserFollower | null
}


export const Follower = ({ setShowFollowers, userPage }: iFollower) => {

    const { followers, user, loadFollowers, loadFollowing } = useContext(UserContext)

    useEffect(() => {
        const loadFollowFollowing = async () => {
            try {
                // setLoading(true);
                if (userPage) {
                    loadFollowers(userPage.id);
                    loadFollowing(userPage.id);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (user) {
            loadFollowFollowing();
        }
    }, [user]);


    return (
        <Follow setShowFollow={setShowFollowers} title="Seguidores">
            {userPage?.Followers.raw.map((wer: any, i: number) => {
                return (
                    <FollowCard wer={wer} userId={userPage.id} key={i} />
                )
            })}
        </Follow>)
}